<template lang="">
    <form id="soap_section">
        <div
            v-for="category in soapContent"
            :key="category.id"
            class="soap_section form_template_category"
        >
            <!-- Looping for each category -->
            <div class="row-fluid">
                <h4 :id="'title_' + category.label.toLowerCase()" href="#">
                    <i
                        :id="category.id + '_arrow'"
                        :class="ICON_SECTION_EXPANDED"
                        v-b-toggle="category.id"
                        style="vertical-align: inherit;"
                    ></i>
                    <a
                        :id="category.id + '_label'"
                        tabIndex="-1"
                        class="form_category_label text-link"
                        v-b-toggle="category.id"
                        >{{ category.label }}</a
                    >
                    <span
                        hidden
                        :id="category.id + '_auto_save'"
                        class="auto-save-message"
                        >(changes saved)</span
                    >
                    <span class="field-locked-message"></span>
                </h4>
            </div>
            <!-- Looping for each component -->
            <div v-if="Object.values(category.data).length > 0">
                <b-collapse
                    v-for="component in Object.values(category.data)"
                    :key="component.id"
                    :id="category.id"
                    class="accordion-body collapse"
                    visible
                >
                    <div class="form_template_component">
                        <!-- component label-->
                        <div
                            v-if="
                                Object.values(component.data).length > 0 &&
                                component.id != 'fm_soap_diagnoses'
                            "
                            class="row-fluid"
                        >
                            <label>
                                <i
                                    :id="`${component.id}_arrow`"
                                    :class="ICON_SECTION_EXPANDED"
                                    v-b-toggle="`collapse_${component.id}`"
                                ></i>
                                <strong>
                                    <a
                                        :id="`${component.id}_label`"
                                        class="form_category_label text-link"
                                        v-b-toggle="`collapse_${component.id}`"
                                        >{{ component.label }}</a
                                    >
                                </strong>
                            </label>
                            <b-collapse
                                v-for="subcomponent in Object.values(
                                    component.data
                                )"
                                :key="subcomponent.id"
                                :id="`collapse_${component.id}`"
                                class="accordion-body collapse"
                                visible
                            >
                                <div class="form_template_subcomponent">
                                    <!-- sub component label-->
                                    <div>
                                        <label v-if="subcomponent.data">
                                            <i
                                                :id="`${subcomponent.id}_arrow`"
                                                :class="ICON_SECTION_EXPANDED"
                                                v-b-toggle="
                                                    `collapse_${subcomponent.id}`
                                                "
                                            ></i>
                                            <strong>
                                                <a
                                                    :id="`${subcomponent.id}_label`"
                                                    class="form_category_label text-link"
                                                    v-b-toggle="
                                                        `collapse_${subcomponent.id}`
                                                    "
                                                    >{{ subcomponent.label }}</a
                                                >
                                            </strong>
                                        </label>
                                        <b-form v-else class="row">
                                            <label
                                                :id="`${subcomponent.id}_label`"
                                                :class="[
                                                    labelCol,
                                                    'font-weight-bold',
                                                    'text-soap-content'
                                                ]"
                                                >{{
                                                    `${subcomponent.label}:`
                                                }}</label
                                            >

                                            <div
                                                class="col-sm-2"
                                                v-if="
                                                    subcomponent.options &&
                                                    subcomponent.options
                                                        .isNumber
                                                "
                                            >
                                                <div
                                                    class="row justify-content-start padding-max-575px"
                                                >
                                                    <div
                                                        :id="`${subcomponent.id}-value`"
                                                    >
                                                        <span
                                                            class="text-soap-content"
                                                        >
                                                            {{
                                                                subcomponent.value
                                                            }}
                                                        </span>
                                                    </div>
                                                    <div
                                                        v-if="
                                                            subcomponent.options
                                                                .defaultValue
                                                        "
                                                        class="ml-1"
                                                    >
                                                        <span
                                                            v-if="
                                                                Object.values(
                                                                    subcomponent
                                                                        .options
                                                                        .options
                                                                ).length > 0
                                                            "
                                                            class="text-soap-content"
                                                        >
                                                            {{
                                                                `${
                                                                    subcomponent
                                                                        .options
                                                                        .options[
                                                                        subcomponent.value_type
                                                                            ? subcomponent.value_type
                                                                            : subcomponent
                                                                                  .options
                                                                                  .defaultValue
                                                                    ]
                                                                }`
                                                            }}
                                                        </span>
                                                        <div
                                                            v-else
                                                            :id="`${subcomponent.id}-value_type`"
                                                        >
                                                            <span
                                                                class="text-soap-content"
                                                                >{{
                                                                    `${
                                                                        subcomponent
                                                                            .options
                                                                            .options[
                                                                            subcomponent.value_type
                                                                                ? subcomponent.value_type
                                                                                : subcomponent
                                                                                      .options
                                                                                      .defaultValue
                                                                        ]
                                                                    }`
                                                                }}</span
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                class="col-sm-2 remove-padding-left-custom"
                                                v-if="
                                                    subcomponent.options &&
                                                    subcomponent.options
                                                        .options &&
                                                    Object.values(
                                                        subcomponent.options
                                                            .options
                                                    ).length > 0 &&
                                                    !subcomponent.options
                                                        .isNumber &&
                                                    subcomponent.options
                                                        .elementValue != '' &&
                                                    !subcomponent.options
                                                        .isDatePicker
                                                "
                                            >
                                                <div
                                                    v-if="
                                                        !subcomponent.options
                                                            .isMultiple
                                                    "
                                                    :id="`${subcomponent.id}-value`"
                                                >
                                                    <span
                                                        class="text-soap-content"
                                                    >
                                                        {{
                                                            subcomponent.options
                                                                .options[
                                                                subcomponent.value
                                                                    ? subcomponent.value
                                                                    : subcomponent
                                                                          .options
                                                                          .defaultValue
                                                            ]
                                                        }}
                                                    </span>
                                                </div>
                                                <div
                                                    v-else-if="
                                                        subcomponent.options
                                                            .isMultiple
                                                    "
                                                    :id="`${subcomponent.id}-value`"
                                                    label="label"
                                                >
                                                    <span
                                                        v-for="(option,
                                                        key) in selectedValues[
                                                            `${subcomponent.id}-value`
                                                        ].map(
                                                            option =>
                                                                option.label
                                                        )"
                                                        :key="key"
                                                        class="text-soap-content"
                                                    >
                                                        {{ option }}
                                                    </span>
                                                </div>
                                            </div>

                                            <div
                                                class="col-sm-2 remove-padding-left-custom"
                                                v-if="
                                                    subcomponent.options &&
                                                    subcomponent.options
                                                        .options2 &&
                                                    Object.values(
                                                        subcomponent.options
                                                            .options2
                                                    ).length > 0 &&
                                                    subcomponent.options
                                                        .defaultValue2
                                                "
                                            >
                                                <div
                                                    :id="`${subcomponent.id}-value2`"
                                                >
                                                    <span
                                                        class="text-soap-content"
                                                    >
                                                        {{
                                                            subcomponent.value2 !=
                                                            ""
                                                                ? subcomponent.value2
                                                                : subcomponent
                                                                      .options
                                                                      .defaultValue2
                                                        }}
                                                    </span>
                                                </div>
                                            </div>

                                            <div
                                                v-if="
                                                    subcomponent.options &&
                                                    subcomponent.options
                                                        .isDatePicker
                                                "
                                                :id="subcomponent.id"
                                                class="col-sm remove-padding-left-custom"
                                            >
                                                <SoapContentLockedNotes
                                                    :content="
                                                        subcomponent.comment
                                                            ? convertToDateFormat(
                                                                  subcomponent.comment
                                                              )
                                                            : null
                                                    "
                                                />
                                            </div>
                                            <div
                                                v-else
                                                class="col-sm remove-padding-left-custom"
                                            >
                                                <SoapContentLockedNotes
                                                    :content="
                                                        decodeHtmlEntities(
                                                            subcomponent.comment
                                                        )
                                                    "
                                                />
                                            </div>
                                        </b-form>
                                    </div>
                                    <!-- Looping for each sub sub component -->
                                    <div
                                        v-if="
                                            subcomponent.data &&
                                            Object.values(subcomponent.data)
                                                .length > 0
                                        "
                                    >
                                        <b-collapse
                                            v-for="subsubcomponent in Object.values(
                                                subcomponent.data
                                            )"
                                            :key="subsubcomponent.id"
                                            :id="`collapse_${subcomponent.id}`"
                                            class="accordion-body collapse"
                                            visible
                                        >
                                            <div
                                                class="form_template_sub_subcomponent"
                                            >
                                                <div class="row">
                                                    <label
                                                        :id="`${subsubcomponent.id}_label`"
                                                        :class="[
                                                            labelCol,
                                                            'font-weight-bold',
                                                            'text-soap-content'
                                                        ]"
                                                    >
                                                        {{
                                                            subsubcomponent.label
                                                        }}:
                                                    </label>

                                                    <div
                                                        class="col-sm-2"
                                                        v-if="
                                                            subsubcomponent.options &&
                                                            subsubcomponent
                                                                .options
                                                                .isNumber
                                                        "
                                                    >
                                                        <div
                                                            class="row justify-content-start padding-max-575px"
                                                        >
                                                            <div
                                                                :id="`${subsubcomponent.id}-value`"
                                                            >
                                                                <span
                                                                    class="text-soap-content"
                                                                >
                                                                    {{
                                                                        subsubcomponent.value
                                                                    }}
                                                                </span>
                                                            </div>
                                                            <div
                                                                v-if="
                                                                    subsubcomponent.value_type
                                                                "
                                                                class="ml-1"
                                                            >
                                                                <span
                                                                    v-if="
                                                                        Object.values(
                                                                            subsubcomponent
                                                                                .options
                                                                                .options
                                                                        )
                                                                            .length >
                                                                        0
                                                                    "
                                                                    class="text-soap-content"
                                                                >
                                                                    {{
                                                                        `${
                                                                            subsubcomponent
                                                                                .options
                                                                                .options[
                                                                                subsubcomponent
                                                                                    .value_type
                                                                            ]
                                                                        }`
                                                                    }}
                                                                </span>
                                                                <span
                                                                    v-else
                                                                    :id="`${subsubcomponent.id}-value_type`"
                                                                    class="text-soap-content"
                                                                >
                                                                    {{
                                                                        `${
                                                                            subsubcomponent.value_type
                                                                                ? subsubcomponent.value_type
                                                                                : subsubcomponent
                                                                                      .options
                                                                                      .defaultValue
                                                                        }`
                                                                    }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="col-sm-2 remove-padding-left-custom"
                                                        v-if="
                                                            subsubcomponent.options &&
                                                            subsubcomponent
                                                                .options
                                                                .options &&
                                                            Object.values(
                                                                subsubcomponent
                                                                    .options
                                                                    .options
                                                            ).length > 0 &&
                                                            !subsubcomponent
                                                                .options
                                                                .isNumber &&
                                                            subsubcomponent
                                                                .options
                                                                .elementValue !=
                                                                '' &&
                                                            !subsubcomponent
                                                                .options
                                                                .isDatePicker
                                                        "
                                                    >
                                                        <div
                                                            v-if="
                                                                Array.isArray(
                                                                    subsubcomponent.options
                                                                ) != true &&
                                                                !subsubcomponent
                                                                    .options
                                                                    .isMultiple
                                                            "
                                                            :id="`${subsubcomponent.id}-value`"
                                                        >
                                                            <span
                                                                class="text-soap-content"
                                                            >
                                                                {{
                                                                    subsubcomponent
                                                                        .options
                                                                        .options[
                                                                        subsubcomponent.value
                                                                            ? subsubcomponent.value
                                                                            : subsubcomponent
                                                                                  .options
                                                                                  .defaultValue
                                                                    ]
                                                                }}
                                                            </span>
                                                        </div>
                                                        <div
                                                            v-else-if="
                                                                subsubcomponent
                                                                    .options
                                                                    .isMultiple
                                                            "
                                                            :id="`${subsubcomponent.id}-value`"
                                                        >
                                                            <span
                                                                v-for="(option,
                                                                key) in selectedValues[
                                                                    `${subsubcomponent.id}-value`
                                                                ].map(
                                                                    option =>
                                                                        option.label
                                                                )"
                                                                :key="key"
                                                                class="text-soap-content"
                                                            >
                                                                {{ option }}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div
                                                        class="col-sm-2 remove-padding-left-custom"
                                                        v-if="
                                                            subsubcomponent.options &&
                                                            subsubcomponent
                                                                .options
                                                                .options2 &&
                                                            Object.values(
                                                                subsubcomponent
                                                                    .options
                                                                    .options2
                                                            ).length > 0 &&
                                                            subsubcomponent
                                                                .options
                                                                .defaultValue2
                                                        "
                                                    >
                                                        <div
                                                            :id="`${subsubcomponent.id}-value2`"
                                                        >
                                                            <span
                                                                class="text-soap-content"
                                                            >
                                                                {{
                                                                    subsubcomponent.value2 !=
                                                                    ""
                                                                        ? subsubcomponent.value2
                                                                        : subsubcomponent
                                                                              .options
                                                                              .defaultValue2
                                                                }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm">
                                                        <SoapContentLockedNotes
                                                            class="remove-padding-left-custom"
                                                            :content="
                                                                decodeHtmlEntities(
                                                                    subsubcomponent.comment
                                                                )
                                                            "
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </b-collapse>
                                    </div>
                                </div>
                            </b-collapse>
                        </div>
                        <div
                            v-if="component.id == 'fm_soap_diagnoses'"
                            style="position: relative;"
                            :class="
                                component.data > 0 ? '' : 'table-responsive '
                            "
                            :id="`${component.id}_label`"
                        >
                            <span class="text-soap-content">
                                <h4>Diagnoses</h4>
                            </span>
                            <div v-if="showDiagnosisComment(component.data)">
                                <span
                                    v-for="subcomponent in component.data"
                                    :key="subcomponent.id"
                                >
                                    <template
                                        v-if="
                                            subcomponent.id ==
                                            'fm_soap_diagnoses_comment'
                                        "
                                    >
                                        <div
                                            v-if="subcomponent.comment"
                                            class="row"
                                        >
                                            <label
                                                :id="`${subcomponent.id}_label`"
                                                :class="[
                                                    labelCol,
                                                    'font-weight-bold',
                                                    'text-soap-content'
                                                ]"
                                                for="inline-form-custom-select-pref"
                                                >{{
                                                    `${subcomponent.label}:`
                                                }}</label
                                            >
                                            <div
                                                class="col-sm remove-padding-left-custom"
                                            >
                                                <SoapContentLockedNotes
                                                    :content="
                                                        decodeHtmlEntities(
                                                            subcomponent.comment
                                                        )
                                                    "
                                                />
                                            </div>
                                        </div>
                                        <list-diagnosis
                                            v-else
                                            class="soap-diagnosis-list"
                                            :patientId="soapDetails.patient_id"
                                        />
                                    </template>
                                </span>
                            </div>
                            <list-diagnosis
                                v-else
                                class="soap-diagnosis-list"
                                :patientId="soapDetails.patient_id"
                            />
                        </div>
                        <div
                            v-if="component.id == 'fm_soap_plan_record'"
                            :id="component.id + '_label'"
                            style="position: relative;"
                            visible
                        >
                            <SoapContentRecordList
                                :recordList="recordList"
                                :isRecordListLoading="isRecordListLoading"
                            />
                        </div>
                        <!-- Looping for each sub component -->
                        <b-form
                            v-if="
                                Object.values(component.data).length == 0 &&
                                component.id != 'fm_soap_diagnoses' &&
                                component.id != 'fm_soap_plan_record'
                            "
                            class="row"
                        >
                            <label
                                :id="`${component.id}_label`"
                                :class="[
                                    labelCol,
                                    'font-weight-bold',
                                    'text-soap-content'
                                ]"
                                for="inline-form-custom-select-pref"
                                >{{ `${component.label}:` }}</label
                            >
                            <div
                                class="col-sm-2"
                                v-if="
                                    component.options &&
                                    component.options.isNumber
                                "
                            >
                                <div
                                    class="row justify-content-start padding-max-575px"
                                >
                                    <div :id="`${component.id}-value`">
                                        <span class="text-soap-content">
                                            {{ component.value }}
                                        </span>
                                    </div>
                                    <div
                                        v-if="component.options.defaultValue"
                                        class="ml-1"
                                    >
                                        <span
                                            v-if="
                                                Object.values(
                                                    component.options.options
                                                ).length > 0
                                            "
                                            class="text-soap-content"
                                        >
                                            {{
                                                `${
                                                    component.options.options[
                                                        component.value_type
                                                            ? component.value_type
                                                            : component.options
                                                                  .defaultValue
                                                    ]
                                                }`
                                            }}
                                        </span>

                                        <div
                                            v-else
                                            :id="`${component.id}-value_type`"
                                            :value="component.value_type"
                                        >
                                            <span class="text-soap-content">{{
                                                component.value_type
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                class="col-sm-2 remove-padding-left-custom"
                                v-if="
                                    component.options &&
                                    component.options.options &&
                                    Object.values(component.options.options)
                                        .length > 0 &&
                                    !component.options.isNumber &&
                                    component.options.elementValue != '' &&
                                    !component.options.isDatePicker
                                "
                            >
                                <div
                                    v-if="
                                        Array.isArray(component.options) !=
                                            true &&
                                        !component.options.isMultiple
                                    "
                                    :id="`${component.id}-value`"
                                >
                                    <span class="text-soap-content">
                                        {{
                                            component.options.options[
                                                component.value
                                                    ? component.value
                                                    : component.options
                                                          .defaultValue
                                            ]
                                        }}
                                    </span>
                                </div>
                                <div
                                    v-else-if="component.options.isMultiple"
                                    :id="`${component.id}-value`"
                                >
                                    <span
                                        v-for="(option, key) in selectedValues[
                                            `${component.id}-value`
                                        ].map(option => option.label)"
                                        :key="key"
                                        class="text-soap-content"
                                    >
                                        {{ option }}
                                    </span>
                                </div>
                            </div>

                            <div
                                class="col-sm-2 remove-padding-left-custom"
                                v-if="
                                    component.options &&
                                    component.options.options2 &&
                                    Object.values(component.options.options2)
                                        .length > 0 &&
                                    component.options.defaultValue2
                                "
                            >
                                <div :id="`${component.id}-value2`">
                                    <span class="text-soap-content">
                                        {{ component.value2 }}
                                    </span>
                                </div>
                            </div>
                            <div class="col-sm remove-padding-left-custom">
                                <SoapContentLockedNotes
                                    :content="
                                        decodeHtmlEntities(component.comment)
                                    "
                                />
                            </div>
                        </b-form>
                    </div>
                </b-collapse>
            </div>
        </div>
    </form>
</template>
<script>
import { DateTime } from "luxon";
import { find } from "lodash";
import SoapContentMixin from "@/mixins/soap-content.js";

export default {
    mixins: [SoapContentMixin],
    components: {
        ListDiagnosis: () =>
            import("@/components/patient-diagnosis/diagnosis-list"),
        SoapContentRecordList: () =>
            import("@/components/soap/soap-content-record-list"),
        SoapContentLockedNotes: () =>
            import("@/components/soap/soap-content-locked-notes")
    },
    props: {
        soapContent: {
            type: [Array, Object]
        },
        recordList: {
            type: Array
        },
        isRecordListLoading: {
            type: Boolean,
            default: false
        }
    },
    computed: {},
    watch: {
        // Not merge yet the soapContent
        soapContent(value, newValue) {
            let selectedValues = {};
            for (let fidx in value) {
                let category = value[fidx];
                if (category.data) {
                    Object.values(category.data).forEach(component => {
                        if (component.options) {
                            selectedValues[
                                `${component.id}-value`
                            ] = this.handleMultipleSelectValue(
                                component.options.defaultValue
                            );
                        }
                        if (component.data) {
                            Object.values(component.data).forEach(
                                subcomponent => {
                                    if (subcomponent.options) {
                                        selectedValues[
                                            `${subcomponent.id}-value`
                                        ] = this.handleMultipleSelectValue(
                                            subcomponent.options.defaultValue
                                        );
                                    }
                                    if (subcomponent.data) {
                                        Object.values(
                                            subcomponent.data
                                        ).forEach(subsubcomponent => {
                                            if (subsubcomponent.options) {
                                                selectedValues[
                                                    `${subsubcomponent.id}-value`
                                                ] = this.handleMultipleSelectValue(
                                                    subsubcomponent.options
                                                        .defaultValue
                                                );
                                            }
                                        });
                                    }
                                }
                            );
                        }
                    });
                }
            }
            this.selectedValues = selectedValues;

            this.$nextTick(() => {
                this.BCollapseEventListener();
            });
        }
    },
    methods: {
        showDiagnosisComment(componentData) {
            if (componentData.length > 0) {
                let subcomponent = find(componentData, {
                    id: "fm_soap_diagnoses_comment"
                });
                return Boolean(subcomponent?.comment);
            }

            return false;
        },
        convertToDateFormat(epochTimestamp) {
            // Convert epoch timestamp in seconds to milliseconds for Luxon
            const dateTime = DateTime.fromMillis(epochTimestamp * 1000);

            // Format the date as desired, e.g., "yyyy-MM-dd"
            return dateTime.toFormat(this._dateFormat);
        },
        scrollToTitleContent(elementId) {
            const element = document.getElementById(elementId + "_label");

            if (element) {
                element.style.scrollMarginTop = "20px";
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "start"
                });
            }
        }
    }
};
</script>
<style scoped>
/* 
    All styles are the same as in soap-content.vue
    Will refactor again by moving this styles into external css
 */
.form_template_category,
.form_preview_category {
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.form_template_component label {
    font-weight: normal;
    font-size: 100%;
}
.form_template_subcomponent label,
.form_template_sub_subcomponent label {
    font-weight: normal;
    font-style: italic;
    font-size: 100%;
}
.input_label {
    font-weight: normal;
}
.category_label {
    font-weight: bold;
    font-size: 120%;
}

.form_template_component {
    background: #fafafa;
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.form_preview_component {
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.form_template_subcomponent,
.form_preview_subcomponent {
    background: #fff;
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}
.form_template_sub_subcomponent,
.form_preview_sub_subcomponent {
    background: #fafafa;
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}
/*for patient medical note*/
.form_category {
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.form_component label {
    font-weight: normal;
    font-size: 100%;
}
.form_subcomponent label {
    font-weight: normal;
    font-style: italic;
    font-size: 100%;
}
.form_sub_subcomponent label {
    font-weight: normal;
    font-style: italic;
    font-size: 100%;
}
.form_input_label {
    font-weight: normal;
}
.form_category_label {
    font-weight: bold;
    font-size: 120%;
    line-height: 2em;
}

.form_component {
    background: #fafafa;
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.form_subcomponent {
    background: #fff;
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}
.form_sub_subcomponent {
    background: #fafafa;
    border: 1px solid #eee;
    padding: 10px 10px 3px 10px;
    margin-bottom: 7px;
}

.label_value {
    font-weight: 0;
}

.field-locked-message,
.auto-save-message {
    padding-left: 9px;
    font-size: 14px;
    font-weight: normal;
    line-height: 1;
    color: #999999;
}
@media (min-width: 576px) {
    .remove-padding-left-custom {
        padding-left: 0px;
    }
}

@media (max-width: 575px) {
    .padding-max-575px {
        padding-left: 1rem;
        padding-right: 1rem;
    }
}

.soap-diagnosis-list {
    overflow-x: auto !important;
}
.text-soap-content {
    line-height: 2em;
}
</style>
